function handleButtons() {
  const buttons = document.querySelectorAll('.button-primary, .button-secondary, .button-tertiary');

  if (!buttons.length > 0) {
    return;
  }

  buttons.forEach((button) => {
    if (button.tagName === 'A' || button.tagName === 'BUTTON') {
      let buttonHTML;
      if (!button.classList.contains('external-link') && button.querySelector('.button-arrow') === null) {
        buttonHTML = `<span class="button-label">${button.innerHTML} <span class="button-arrow" focusable="false" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="20" viewBox="0 0 8 20" fill="none">
                              <path d="M8 9.66601C8 9.66601 7.12215 4.99797 0 5C0 5 2.02298 6.91724 2.03583 9.66674C2.02298 12.4161 1.90735e-06 14.3333 1.90735e-06 14.3333C7.12216 14.3354 8 9.66601 8 9.66601Z" fill="white"/>
                            </svg>
                          </span>
                     </span>`;
      } else {
        buttonHTML = `<span class="button-label">${button.innerHTML}</span>`;
      }
      button.innerHTML = buttonHTML;
      const span = document.createElement('span');
      span.classList.add('button-circle');
      button.appendChild(span);

      button.addEventListener('mouseenter', (e) => {
        const rect = button.getBoundingClientRect();
        const relX = e.clientX - rect.left;
        const relY = e.clientY - rect.top;
        const scale = Math.round((Math.abs(relX - button.offsetWidth / 2) / (button.offsetWidth / 2) + 1) * 100);
        span.style.width = `calc(${scale}% + 48px)`;
        span.style.top = `${relY}px`;
        span.style.left = `${relX}px`;
      });

      button.addEventListener('mouseout', (e) => {
        const rect = button.getBoundingClientRect();
        const relX = e.clientX - rect.left;
        const relY = e.clientY - rect.top;
        span.style.width = '0%';
        span.style.top = `${relY}px`;
        span.style.left = `${relX}px`;
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', handleButtons);
